import './App.css';
import Main from './components/Main/Main';
import settings from './data/settings';
import { useEffect, useState } from 'react';

function App() {
  let marginLeft;
  useEffect(() => {
    // const calculateMargin = () => {
    //   const hamburgerButton = document.getElementById(
    //     'viergradMenuHamburgerButton'
    //   );
    //   const fontSize = parseFloat(
    //     getComputedStyle(document.documentElement).fontSize
    //   );

    //   const desiredDistanceFromRightEdge = 2 * fontSize;
    //   const buttonWidth = 67;
    //   const windowWidth = window.innerWidth;
    //   const newMarginLeft =
    //     windowWidth - buttonWidth - desiredDistanceFromRightEdge;
    //   marginLeft = `${newMarginLeft}px`;
    //   hamburgerButton.style.marginLeft = marginLeft;
    // };
    // // console.log('Settings align : ', settings.alignment);
    // if (settings.alignment.navigation === 'right') {
    //   console.log('USAO SAM!');
    //   calculateMargin();
    //   window.addEventListener('resize', calculateMargin);
    // }

    // calculateMargin();
    // window.addEventListener('resize', calculateMargin);

    // Moving menu behind the wordpress admin bar (in case of menu animation button)
    // let marginTop = 0;
    // const wpAdminBar = document.getElementById('wpadminbar');
    // console.log('WP ADMIN BAR: ', wpAdminBar);
    // if (wpAdminBar && window.getComputedStyle(wpAdminBar).display !== 'none') {
    //   const adminBarHeight = wpAdminBar.offsetHeight;
    //   marginTop = adminBarHeight;
    // }

    // Dodati margin-top: ${marginTop}px; u .ReactModal__Overlay

    // Dynamic create styles for the MenuLeft.js and MenuRight.js
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = `
      .ReactModal__Overlay {
        opacity: 0.5;
        transform: ${
          settings.alignment.navigation === 'left'
            ? 'translateX(-100%)'
            : 'translateX(100%)'
        };
        transition-duration: 0.25s;
        transition-timing-function: ease-out;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
      .ReactModal__Overlay--after-open {
        opacity: 1;
        transform: translateX(0%);
      }
      .ReactModal__Content--before-close {
        transform: ${
          settings.alignment.navigation === 'left'
            ? 'translateX(-100%)'
            : 'translateX(100%)'
        };
        transition-duration: 0.5s;
      }

      // body.ReactModal__Body--open {
      //   overflow-y: hidden;
      //   pointer-events: none;
      // }

      @media (max-width: 768px) {
        .ReactModal__Overlay--before-close {
          transform: ${
            settings.alignment.navigation === 'left'
              ? 'translateX(-100%, 100%)'
              : 'translateX(100%, -100%)'
          };
          transition-duration: 0.5s;
        }
      }
      @media (min-width: 769px) {
        .ReactModal__Overlay--before-close {
          transform: ${
            settings.alignment.navigation === 'left'
              ? 'translateX(-100%, 100%)'
              : 'translateX(100%, -100%)'
          };
          transition-duration: 0.5s;
        }
      }
      
      // Close Button position depending on navigation direction

      .menuButton {
        width: 67px;
        height: 54px;
        margin-top: 0px;
        // margin-left: 24px;
        background-image: linear-gradient(to right, #fff, transparent);
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-self: center;
        align-content: center;
      }

      .menuButtonWrapper {
        postition: fixed;
        top: 2rem;
        ${
          settings.alignment.navigation === 'left'
            ? 'left: 2rem;'
            : 'right: 2rem;'
        }
        z-index: 10000000000000000000001;
      }
        
      .menuButton div {
        width: 40px;
        height: 32px;
        margin: 10px;
        position: relative;
      }
      
      .menuButton span {
        background: #333;
        width: 100%;
        height: 3px;
        border-radius: 5px;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.25s, width 0.25s;
      }
      
      .menuButton .line-1 {
        transform: translate(-50%, -13px);
      }
      
      .menuButton .line-3 {
        transform: translate(-50%, 11px);
      }
      
      .openmenu .line-1 {
        transform: translate(-50%, -50%) rotate(45deg);
      }
      
      .openmenu .line-3 {
        transform: translate(-50%, -50%) rotate(-45deg);
      }
      
      .openmenu .line-2 {
        width: 0;
      }      
    `;
    document.head.appendChild(styleSheet);

    return () => {
      // Cleaning function after component disappears
      document.head.removeChild(styleSheet);
      // window.removeEventListener('resize', calculateMargin);
    };
  }, [marginLeft]);

  return (
    <div className='App'>
      <Main />
    </div>
  );
}

export default App;
